import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';

@Component({
    selector: 'app-crop-image',
    templateUrl: './crop-image.component.html',
    styleUrls: ['./crop-image.component.scss'],
    standalone: true,
    imports: [CommonModule, ImageCropperComponent],
})
export class CropImageComponent implements OnInit {
    @Input() imageSrc: string = '';
    @Input() aspectRatio: number = 1; // default to square crop
    @Output() cropSaved = new EventEmitter<{ base64: string, cropData: any }>();

    croppedImage: string = '';
    cropData: any = null;
    imageChangedEvent: any = null;

    ngOnInit() {
        // If imageSrc exists, no need to upload, so imageChangedEvent is not needed
        if (this.imageSrc) {
            // If imageSrc is a URL, fetch and convert to base64
            if (this.isUrl(this.imageSrc)) {
                this.urlToBase64(this.imageSrc)
                    .then((base64: string) => {
                        this.imageSrc = base64;
                        this.imageChangedEvent = null;
                    })
                    .catch(() => {
                        // handle error if needed
                        this.imageSrc = '';
                        this.imageChangedEvent = null;
                    });
            } else {
                this.imageChangedEvent = null;
            }
        }
    }

    fileChangeEvent(event: any): void {
        // Only allow file upload if imageSrc is not provided
        if (!this.imageSrc) {
            this.imageChangedEvent = event;
        }
    }

    onImageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64 || '';
        this.cropData = {
            cropperPosition: event.cropperPosition,
            width: event.width,
            height: event.height,
            imagePosition: event.imagePosition
        };
    }

    onImageLoaded() {
        // Image loaded in cropper
    }

    onCropperReady() {
        // Cropper ready
    }

    onLoadImageFailed() {
        // Show error message
    }

    saveCrop() {
        this.cropSaved.emit({
            base64: this.croppedImage,
            cropData: this.cropData
        });
    }

    resetCrop() {
        this.croppedImage = '';
        this.cropData = null;
    }

    private isUrl(str: string): boolean {
        try {
            // Accepts http, https, and protocol-relative URLs
            return /^https?:\/\/|^\/\//i.test(str);
        } catch {
            return false;
        }
    }

    private urlToBase64(url: string): Promise<string> {
        return new Promise((resolve, reject) => {
            try {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => {
                    try {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        if (!ctx) {
                            reject('Canvas context is null');
                            return;
                        }
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL('image/png');
                        resolve(dataURL);
                    } catch (e) {
                        reject(e);
                    }
                };
                img.onerror = (err) => {
                    reject(err);
                };
                img.src = url;
                // Handle cached images which may not trigger onload
                if (img.complete || img.complete === undefined) {
                    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                    img.src = url;
                }
            } catch (e) {
                reject(e);
            }
        });
    }
}
